import { type QuickMdState } from '@/app/store'
import { type Patient } from '@/types/patient'
import { type RecentlyViewedChart } from '../../pages/patient-charts/recentlyViewed'

export function selectPatientInfo(state: QuickMdState): Record<string, Patient> {
  return state.chartsReducer.patientInfo
}

export function selectRecentlyViewed(state: QuickMdState): RecentlyViewedChart[] {
  return state.chartsReducer.recentlyViewed
}
